/**
 * Feature Flags - Sistema de controle de funcionalidades
 *
 * Para desabilitar uma funcionalidade, mude o valor para false
 * Para reabilitar, mude para true
 *
 * SEGMENTOS:
 * 1 = Leite
 * 2 = Grãos
 */

export const FEATURE_FLAGS = {
    // Plano de Trabalho
    PLANO_TRABALHO: {
        enabled: false,
        segments: [2] // Disponível para quais segmentos quando habilitado
    },

    // Agenda do Consultor
    AGENDA: {
        enabled: true,
        segments: [2]
    },

    // Endereço do Consultor (no cadastro/perfil)
    ENDERECO_CONSULTOR: {
        enabled: true,
        segments: [2]
    },

    // Latitude, Longitude e Altitude da Fazenda
    GEOLOCALIZACAO_FAZENDA: {
        enabled: true,
        segments: [2]
    },

    // Eventos ao Vivo (Encontros ao vivo)
    EVENTOS_AO_VIVO: {
        enabled: true,
        segments: [2]
    },

    // Pop-up Proprietário da Fazenda
    POPUP_PROPRIETARIO: {
        enabled: false,
        segments: [2, 1]
    },

    // Rehagro Blog/Posts
    REHAGRO_BLOG: {
        enabled: true,
        segments: [2]
    },

    // Notificações
    NOTIFICACOES: {
        enabled: true,
        segments: [2]
    },

    // Visão Geral (Admin)
    VISAO_GERAL_ADMIN: {
        enabled: false,
        segments: [1, 2]
    },

    // Campos extras do Plano de Ação - FORMULÁRIOS (informações pouco usadas)
    PLANO_ACAO_CAMPO_ONDE: {
        enabled: true,
        segments: [2]
    },

    PLANO_ACAO_CAMPO_PRIORIDADE: {
        enabled: true,
        segments: [2]
    },

    PLANO_ACAO_CAMPO_DATA_INICIO: {
        enabled: true,
        segments: [2]
    },

    // Colunas extras do Plano de Ação - TABELAS (controle independente)
    PLANO_ACAO_TABELA_COLUNA_ONDE: {
        enabled: true,
        segments: [2]
    },

    PLANO_ACAO_TABELA_COLUNA_PRIORIDADE: {
        enabled: true,
        segments: [2]
    },

    PLANO_ACAO_TABELA_COLUNA_DATA_INICIO: {
        enabled: true,
        segments: [2]
    },

    // Dados da tela de engajamento

    DADOS_TELA_DE_ENGAJAMENTO: {
        enabled: true,
        segments: [1]
    }
};

/**
 * Verifica se uma feature está habilitada para o segmento atual
 * @param {string} featureName - Nome da feature (chave do FEATURE_FLAGS)
 * @param {number} currentSegment - Segmento atual (1=Leite, 2=Grãos)
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureName, currentSegment = 1) => {
    const feature = FEATURE_FLAGS[featureName];

    if (!feature) {
        console.warn(`Feature flag "${featureName}" não encontrada`);
        return true; // Default: habilitado se não existir
    }

    // Verifica se está habilitado E se o segmento atual está na lista
    return feature.enabled && feature.segments.includes(currentSegment);
};

/**
 * Hook personalizado para usar feature flags com Redux
 * Usar em componentes funcionais
 */
export const useFeatureFlag = (featureName) => {
    // Este hook será implementado nos componentes que usam Redux
    // Exemplo de uso será fornecido na documentação
    return { isFeatureEnabled };
};

export default FEATURE_FLAGS;
